exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gift_title{font-size:17px;font-weight:700;color:#ee0a24}", ""]);

// exports
